// Соединение берём общее, через initializeDB: сырой openDB(DB_NAME, DB_VERSION)
// заводил на каждый вызов отдельное соединение и никогда его не закрывал.
// Пока версия БД не менялась, это просто копило коннекты; при смене версии
// апгрейд вставал намертво, ожидая их закрытия, и приложение зависало.
import { initializeDB } from '../config/db';
import { GAS_LINE_INSPECTION_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const gasLineInspectionService = {
    /**
     * Submit gas line inspection to server
     */
    async submit(inspection) {
        try {
            const response = await axiosInstance.post('/gas-line-inspection/submit', inspection);
            return response.data;
        } catch (error) {
            console.error('Error submitting gas line inspection:', error);
            throw error;
        }
    },

    /**
     * Save gas line inspection as draft in IndexedDB
     */
    async saveDraft(inspection) {
        const db = await initializeDB();
        const now = new Date().toISOString();

        const inspectionToSave = {
            ...inspection,
            updatedAt: now
        };

        // Only set status to draft if not already set
        if (!inspectionToSave.status) {
            inspectionToSave.status = 'draft';
        }

        if (!inspectionToSave.createdAt) {
            inspectionToSave.createdAt = now;
        }

        await db.put(GAS_LINE_INSPECTION_STORE, inspectionToSave);
        return inspectionToSave;
    },

    /**
     * Load gas line inspection by UUID from IndexedDB
     */
    async loadByUuid(uuid) {
        const db = await initializeDB();
        return await db.get(GAS_LINE_INSPECTION_STORE, uuid);
    },

    /**
     * Get all gas line inspections from IndexedDB
     */
    async getAll() {
        const db = await initializeDB();
        return await db.getAll(GAS_LINE_INSPECTION_STORE);
    },

    /**
     * Delete gas line inspection from IndexedDB
     */
    async delete(uuid) {
        const db = await initializeDB();
        await db.delete(GAS_LINE_INSPECTION_STORE, uuid);
    }
};

export default gasLineInspectionService;
